const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return 'N/A';
    return date.toLocaleString();
};

const formatType = (type) => {
    if (!type) return 'Activity';
    return type.charAt(0).toUpperCase() + type.slice(1);
};

const getTypeColors = (type) => {
    switch ((type || '').toLowerCase()) {
        case 'email':
            return {
                accent: '#7c3aed',
                badgeBg: '#f3e8ff',
                badgeText: '#6d28d9',
                badgeBorder: '#c4b5fd'
            };
        case 'activity':
            return {
                accent: '#638a47',
                badgeBg: '#dff0d8',
                badgeText: '#2e4a1f',
                badgeBorder: '#5ca340'
            };
        case 'note':
            return {
                accent: '#0074a9',
                badgeBg: '#e0f2fe',
                badgeText: '#0369a1',
                badgeBorder: '#7dd3fc'
            };
        default:
            return {
                accent: '#4b5563',
                badgeBg: '#f3f4f6',
                badgeText: '#374151',
                badgeBorder: '#d1d5db'
            };
    }
};

const toPlainText = (value) => {
    if (!value) return '';
    return value
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
};

const formatDetailLabel = (key) => {
    return key
        .replace(/^hs_/, '')
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const FeedTable = ({ feed = [], loading = false, error = '' }) => {
    if (loading) {
        return (
            <div className="feed-state-message">
                <p>Loading project feed...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="feed-state-message feed-state-error">
                <p>{error}</p>
            </div>
        );
    }

    if (feed.length === 0) {
        return (
            <div className="feed-table-empty">
                <p>No feed activity is available for this project.</p>
                <p>Feed items from HubSpot and project events will appear here.</p>
            </div>
        );
    }

    const sortedFeed = [...feed].sort((a, b) => {
        const timeA = new Date(a.timestamp || a.created_at || 0).getTime();
        const timeB = new Date(b.timestamp || b.created_at || 0).getTime();
        return timeB - timeA;
    });

    return (
        <div className="feed-list">
            {sortedFeed.map((item) => {
                const title = toPlainText(item.title) || 'Untitled activity';
                const summary = toPlainText(item.summary);
                const timestamp = formatDateTime(item.timestamp || item.created_at);
                const updatedAt = formatDateTime(item.updated_at);
                const type = formatType(item.object_type);
                const source = item.source || 'Unknown';
                const typeColors = getTypeColors(item.object_type);
                const detailEntries = Object.entries(item.details || {})
                    .filter(([key, value]) => key !== 'hs_timestamp' && value !== null && value !== undefined && String(value).trim() !== '');

                return (
                    <article
                        className="feed-card"
                        key={item.id}
                        style={{
                            '--feed-accent': typeColors.accent,
                            '--feed-badge-bg': typeColors.badgeBg,
                            '--feed-badge-text': typeColors.badgeText,
                            '--feed-badge-border': typeColors.badgeBorder
                        }}
                    >
                        <header className="feed-card-header">
                            <div className="feed-card-meta">
                                <span className="status-chip status-chip--xs status-chip--feed status-chip--feed-type">{type}</span>
                                <span className="status-chip status-chip--xs status-chip--feed">{source}</span>
                            </div>
                            <time className="feed-time">{timestamp}</time>
                        </header>

                        <h4 className="feed-title">{title}</h4>

                        {summary && summary !== title && (
                            <p className="feed-summary">{summary}</p>
                        )}

                        {detailEntries.length > 0 && (
                            <div className="feed-details-grid">
                                {detailEntries.map(([key, value]) => (
                                    <div className="feed-detail-item" key={`${item.id}-${key}`}>
                                        <span className="feed-detail-label">{formatDetailLabel(key)}:</span>
                                        <span className="feed-detail-value">{String(value)}</span>
                                    </div>
                                ))}
                            </div>
                        )}

                        <footer className="feed-footer">
                            <small className="feed-id">ID: {item.object_id || item.id}</small>
                            <small className="feed-updated">Updated: {updatedAt}</small>
                        </footer>
                    </article>
                );
            })}
        </div>
    );
};
